import type { IRogue } from "../services/RogueTypes"

export const REGEX = {
  timestamp: /^(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}.\d{1,3}Z$/,
}

/**
 * @param {string} timestamp "YYYY-MM-DDTHH:MM:SS.msZ"
 * @return {Date|null}
 */
export function getDateObjectFromTimestamp(timestamp: string): Date | null {
  if (!timestamp) {
    return null
  }

  const regexMatch = timestamp.match(REGEX.timestamp)
  if (!regexMatch) {
    console.error('timestamp doesn\'t match the required pattern')

    return null
  }

  const [fullMatch, year, month, day] = regexMatch

  return new Date(+year, +month - 1, +day)
}

/**
 * @param {string} timestamp "YYYY-MM-DDTHH:MM:SS.msZ"
 * @param {string} locale
 * @return {string}
 */
export function date(timestamp: string, locale = navigator.language, short = false) {
  if (!timestamp) {
    return ''
  }
  const d = getDateObjectFromTimestamp(timestamp)
  const localeStringOptions: Intl.DateTimeFormatOptions = {
    year  : 'numeric',
    month : short ? 'short' : 'long',
    day   : 'numeric',
  }

  return d?.toLocaleString(locale, localeStringOptions)
}

export function formatDate(dateInput: string | number | Date | undefined, rogue?: IRogue): string {
  if (!dateInput) {
    return ''
  }

  if (dateInput instanceof Number) {
    if (dateInput as number < new Date(1950).getTime()) {
      dateInput = (dateInput as number) * 1000
    }
  }

  const dateObj = new Date(dateInput)

  if (Number.isNaN(dateObj.getTime())) {
    return ''
  }

  const locale = navigator.languages?.[0] || rogue?.l10n.locale || undefined

  return dateObj.toLocaleDateString(locale, {
    year  : 'numeric',
    month : 'long',
    day   : 'numeric',
  })
}
